import TWEEN from '@tweenjs/tween.js';
let frameAction = () => {};
let paused = false;
let pausedTweens = [];
let frameId = null;
export function animateFrame() {
  if (frameId !== null || paused) return;
  const tick = () => {
    frameId = null;
    if (paused) return;
    const active = TWEEN.update();
    frameAction();
    if (active) frameId = requestAnimationFrame(tick);
  };
  frameId = requestAnimationFrame(tick);
}
export function setFrameAction(cb) { frameAction = cb; }
export function pauseAnimations() {
  if (paused) return;
  paused = true;
  pausedTweens = TWEEN.getAll();
  pausedTweens.forEach(tween => tween.pause());
  if (frameId !== null) cancelAnimationFrame(frameId);
  frameId = null;
}
export function resumeAnimations() {
  pausedTweens.forEach(tween => tween.resume());
  pausedTweens = [];
  paused = false; animateFrame();
}
export function resetAnimations() {
  pausedTweens.forEach(tween => tween.stop());
  pausedTweens = [];
  TWEEN.removeAll(); paused = false;
  if (frameId !== null) cancelAnimationFrame(frameId);
  frameId = null;
}
